export default {
  COMPONENTS: {
    TITLE: 'Mikel Garcia Urbina',
  },
  MENU: {
    CV: 'Curriculum Vitae',
    GITHUB: 'GitHub',
    HISTORY: 'History!',
    LINKEDIN: 'LinkedIn',
  },
};



// WEBPACK FOOTER //
// ./src/constants/text.js